(() => {
  const stockBySize = Object.freeze({
    XS: 3,
    S: 5,
    M: 2,
    L: 1,
    XL: 3,
    XXL: 2,
    XXXL: 4,
  });

  const sizeAliases = Object.freeze({
    'X-SMALL': 'XS',
    XSMALL: 'XS',
    SMALL: 'S',
    MEDIUM: 'M',
    LARGE: 'L',
    'X-LARGE': 'XL',
    XLARGE: 'XL',
    '2X': 'XXL',
    '2XL': 'XXL',
    '2X-LARGE': 'XXL',
    '3X': 'XXXL',
    '3XL': 'XXXL',
    '3X-LARGE': 'XXXL',
  });

  let frameId;
  let followUpTimers = [];

  function normalizeSize(rawValue) {
    const value = String(rawValue || '').trim().toUpperCase().replace(/\s+/g, '');
    return sizeAliases[value] || value;
  }

  function productScope(stockBar) {
    return stockBar.closest('product-info')
      || stockBar.closest('.shopify-section')
      || document;
  }

  function selectedSize(stockBar) {
    const scope = productScope(stockBar);
    const fieldsets = [...scope.querySelectorAll('fieldset')];

    for (const fieldset of fieldsets) {
      const checked = fieldset.querySelector('input:checked');
      if (!checked) continue;
      const optionName = String(checked.name || '').toLowerCase();
      const legend = fieldset.querySelector('legend');
      const legendText = String(legend?.textContent || '').trim().toLowerCase();
      if (optionName.includes('size') || legendText.startsWith('size')) {
        return normalizeSize(checked.value);
      }
    }

    const selects = [...scope.querySelectorAll('select')];
    const sizeSelect = selects.find((select) => {
      const optionName = String(select.name || '').toLowerCase();
      const label = select.id ? scope.querySelector(`label[for="${CSS.escape(select.id)}"]`) : null;
      return optionName.includes('size')
        || String(label?.textContent || '').trim().toLowerCase().startsWith('size');
    });
    return sizeSelect ? normalizeSize(sizeSelect.value) : null;
  }

  function updateStockBar(stockBar) {
    const size = selectedSize(stockBar);
    const count = stockBySize[size];
    if (!count) return;

    const countNode = stockBar.querySelector('#randomStockNumber, [data-alice-stock-count]');
    if (!countNode) return;

    stockBar.setAttribute('aria-live', 'polite');
    stockBar.dataset.aliceSelectedSize = size;
    countNode.dataset.aliceStockCount = '';
    if (countNode.textContent !== String(count)) countNode.textContent = String(count);
  }

  function updateAllStockBars() {
    document.querySelectorAll('.stock-info-cstm').forEach(updateStockBar);
  }

  function scheduleUpdate() {
    cancelAnimationFrame(frameId);
    frameId = requestAnimationFrame(updateAllStockBars);
    followUpTimers.forEach(clearTimeout);
    followUpTimers = [75, 300, 900].map((delay) => setTimeout(updateAllStockBars, delay));
  }

  function isVariantControl(element) {
    if (!(element instanceof HTMLInputElement || element instanceof HTMLSelectElement)) return false;
    const optionName = String(element.name || '').toLowerCase();
    return optionName.includes('size')
      || Boolean(element.closest('variant-selects, variant-radios, variant-select'));
  }

  function init() {
    scheduleUpdate();
    document.addEventListener('change', (event) => {
      if (isVariantControl(event.target)) scheduleUpdate();
    });
    document.addEventListener('shopify:section:load', scheduleUpdate);

    new MutationObserver((mutations) => {
      const stockMarkupChanged = mutations.some((mutation) =>
        [...mutation.addedNodes].some((node) =>
          node instanceof Element
          && (node.matches('.stock-info-cstm') || node.querySelector('.stock-info-cstm'))
        )
      );
      if (stockMarkupChanged) scheduleUpdate();
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
